import React, { useEffect, useState } from 'react';
import { PageSubTitle } from 'Components/Titles';
import { StubLabel } from 'Components/Texts';
import { fetchProfileInfo } from 'State/User';
import { useStore } from 'Hooks/useStore';
import './ManageProfile.css';
import { TRACKING_ENUMS, tealiumTrackEvent, trackEvent } from 'Utils/Analytics';
import { updateConfirmation } from 'State/Layout';
import { getAppConfig } from 'State/store';
import { useLocation, useNavigate } from 'react-router-dom';

const EMAIL_UPDATE_PATH = 'email-update';
const PASSWORD_UPDATE_PATH = 'password-update';
const SERVICE_ACTION_QUERY_PARAM = 'serviceAction';
const SERVICE_SUCCESS_QUERY_PARAM = 'success';

export const ManageProfile = ({ subTitle, routes, trackEditAccount }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useStore('user');
  const [serviceActionResult, setServiceActionResult] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const initialParamsCount = urlParams.size;
    const serviceAction = getAndRemoveUrlParam(urlParams, SERVICE_ACTION_QUERY_PARAM);
    const serviceSuccess = getAndRemoveUrlParam(urlParams, SERVICE_SUCCESS_QUERY_PARAM);

    if (serviceAction && serviceSuccess == 'true') {
      setServiceActionResult({ action: serviceAction });
    }
    if (initialParamsCount != urlParams.size) {
      navigate({ pathname: location.pathname, search: urlParams.toString() }, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    if (serviceActionResult) {
      switch (serviceActionResult.action) {
        case EMAIL_UPDATE_PATH:
          (async () => {
            await fetchProfileInfo();
            updateConfirmation('Your email address has been updated.');
          })();
          break;
        case PASSWORD_UPDATE_PATH:
          updateConfirmation('Your password has been updated.');
          trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_FORGOT_PASSWORD, {
            page_item_title: 'Save Changes',
          });
          tealiumTrackEvent(TRACKING_ENUMS.EVENT_EDIT_PASSWORD_COMPLETED, {
            button_text: 'Save Changes',
            button_location: 'my account',
          });
          trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_PASSWORD_UPDATED, {
            page_item_title: 'Save Changes',
          });
          break;
      }
      setServiceActionResult(null);
    }
  }, [serviceActionResult]);

  const { email, hasMvpd, profileId } = user;

  if (hasMvpd) return null;
  return (
    <div className="sectionFlex profileSettings">
      <div className="sectionFlex flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <div className="sectionFlex infoRow">
          <div className="sectionFlex infoRowLeft">
            <StubLabel className="profileLabel" text="Email:" />
            <div className="emailValue">
              <span className="stubValue" data-dd-privacy="mask" data-heap-redact-text>
                {email}
              </span>
            </div>
          </div>
          <div className="linksCol">
            <button
              onClick={() => {
                goToAuthManagePath({ path: EMAIL_UPDATE_PATH });
              }}
              className="profileLink"
            >
              <span className="profileLinkTest">Edit Email Address</span>
            </button>
          </div>
        </div>
        <div className="sectionFlex infoRow">
          <div className="sectionFlex infoRowLeft">
            <StubLabel className="profileLabel" text="Password:" />
            <span className="stubValue">............</span>
          </div>
          <div className="linksCol">
            <button
              onClick={() => {
                trackEditAccount('Edit Password');
                goToAuthManagePath({ path: PASSWORD_UPDATE_PATH });
              }}
              className="profileLink"
            >
              <span className="profileLinkTest">Edit Password</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function getAndRemoveUrlParam(urlSearchParams, name) {
  const value = urlSearchParams.get(name);
  if (value != null) urlSearchParams.delete(name);
  return value;
}

function goToAuthManagePath({ path }) {
  const { authManageUrl } = getAppConfig().defaultConfig;
  const url = new URL(`${authManageUrl}${path}`);
  const backUrl = new URL(window.location.href);
  backUrl.searchParams.set(SERVICE_ACTION_QUERY_PARAM, path);
  url.searchParams.set('back_url', backUrl.toString());
  window.location.href = url.toString();
}
